import {
  GET_LEAD_STATUS_LIST,
  GET_LEAD_STATUS_LIST_ERROR,
  CLEAN_GET_CAMPAING,
  CLEAN_GET_CAMPAING_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function getLeadStatusListReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LEAD_STATUS_LIST:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case GET_LEAD_STATUS_LIST_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_GET_CAMPAING:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_GET_CAMPAING_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
